// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","menuItemsContainer":"menu_menuItemsContainer__1v1r_","menuItems":"menu_menuItems__2hHvL","menuLink":"menu_menuLink__FXA_J"};